// Live-feed clients (ARCHITECTURE §2: only the data layer calls fetch). Each client is one
// provider; the services layer decides what to poll, when, and what a failure means.

import { fromDate } from '../../core/dates.ts';
import type { Fetcher } from '../types.ts';
import { eonetEvents } from './eonet.ts';
import { gdacsAlerts } from './gdacs.ts';
import { browserFetch } from './http.ts';
import { ll2Launches } from './ll2.ts';
import { portwatchChokepoints } from './portwatch.ts';
import { worldHeadlines } from './rss.ts';
import type { FeedClients } from './types.ts';
import { usgsQuakes } from './usgs.ts';

export type { FeedClients, LiveKind, LiveRecord } from './types.ts';

export interface FeedOptions {
  /** Defaults to the global fetch. Tests pass a canned one. */
  fetch?: Fetcher;
  /** Wall clock, for the providers that take a date window. */
  now?: () => Date;
}

export function createFeedClients(opts: FeedOptions = {}): FeedClients {
  const fetcher = opts.fetch ?? browserFetch;
  const now = opts.now ?? (() => new Date());

  return {
    quakes: () => usgsQuakes(fetcher),
    alerts: () => gdacsAlerts(fetcher, now()),
    events: () => eonetEvents(fetcher),
    chokepoints: () => portwatchChokepoints(fetcher, fromDate(now())),
    launches: () => ll2Launches(fetcher),
    headlines: () => worldHeadlines(fetcher),
  };
}
